import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import ColoredLabelsInBoardQuery, {
	type coloredLabelsUpdater_getLabelsInBoardQuery,
} from '@atlassian/jira-relay/src/__generated__/coloredLabelsUpdater_getLabelsInBoardQuery.graphql';
import type { RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_COLORED_LABELS_RELAY } from '../constants.tsx';

export const coloredLabelsResource: RouteResource<
	PreloadedQuery<coloredLabelsUpdater_getLabelsInBoardQuery, Record<string, unknown>>
> = createRelayResource<coloredLabelsUpdater_getLabelsInBoardQuery>({
	type: RESOURCE_TYPE_COLORED_LABELS_RELAY,
	getQuery: ({ query, match }, { tenantContext }) => {
		const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;

		let boardAriId = null;

		try {
			boardAriId = boardId
				? `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`
				: '';
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'getBoardAriId',
					packageName: 'jiraSoftwareBoard',
					teamName: 'gryffindor',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		return {
			parameters: ColoredLabelsInBoardQuery,
			variables: {
				boardId: boardAriId || '',
			},
			options: { fetchPolicy: 'network-only' },
		};
	},
	isBrowserOnly: true,
});
